// Student name mapping for display purposes
// This overrides the names shown in the teacher page without changing the database
// Format: { studentId: "Display Name" }

export const studentNameOverrides = {
  // Example entries:
  // "student123": "John Smith",
  // "6896043dd34527de7df8c5fc": "Jane Doe",

  // Add your mappings here:
  "6896a06071507757bf0b90b8": "郭沐依", // jerry
  "6897609cc6e6907695b4ce01": "刘娢孜", // 胡文娟
  "68976856aec4ea512bb40bfd": "杨谨瑜", // 杨安琴

  // Mock test students (easy to identify and clean up)
  "alice-test-001": "Alice (Test)",
  "bob-test-002": "Bob (Test)",
  "carol-test-003": "Carol (Test)",
  "david-test-004": "David (Test)",
  "emma-test-005": "Emma (Test)",
  "frank-test-006": "Frank (Test)",
  "grace-test-007": "Grace (Test)",
  "henry-test-008": "Henry (Test)",
  "ivy-test-009": "Ivy (Test)",
  "jack-test-010": "Jack (Test)",
  "kate-test-011": "Kate (Test)",
  "leo-test-012": "Leo (Test)",
  "mia-test-013": "Mia (Test)",
};

// Cache for Authing user names (populated when teacher page loads users)
// Map: studentId -> displayName
let authingUsersCache = new Map();

/**
 * Populate the Authing users cache
 * Call this when loading users from Authing API
 * @param {Array} users - Array of { studentId, displayName } or { id, name }
 */
export const setAuthingUsersCache = (users) => {
  authingUsersCache = new Map();
  if (Array.isArray(users)) {
    users.forEach(user => {
      const id = user.studentId || user.id;
      const name = user.displayName || user.name;
      if (id && name) {
        authingUsersCache.set(id, name);
      }
    });
  }
};

/**
 * Get display name from Authing cache
 * @param {string} studentId
 * @returns {string|undefined}
 */
export const getAuthingUserName = (studentId) => {
  return authingUsersCache.get(studentId);
};

/**
 * Get student display name with consistent priority:
 * 1. Manual overrides (studentNameOverrides)
 * 2. Authing user cache (from API)
 * 3. Provided fallback name (e.g., from enrollment record)
 * 4. Student ID as last resort
 *
 * @param {string} studentId - The student's ID
 * @param {string} [fallbackName] - Optional fallback (e.g., student_name from DB)
 * @returns {string} The display name
 */
export const getStudentDisplayName = (studentId, fallbackName) => {
  // 1. Check manual overrides first
  if (studentNameOverrides[studentId]) {
    return studentNameOverrides[studentId];
  }

  // 2. Check Authing cache
  const authingName = authingUsersCache.get(studentId);
  if (authingName) {
    return authingName;
  }

  // 3. Use provided fallback name
  if (fallbackName) {
    return fallbackName;
  }

  // 4. Last resort: return the ID
  return studentId;
};
